import Tournament from './Tournament';
import Sport from './Sport';
import Category from './Category';
import Bet from './Bet';
import BetGroup from './BetGroup';
import Match from './Match';
import parserMap from './parser-map';

const formatMeta = (rawData) => {
  const tournaments = {};
  const categories = {};
  const sports = {};
  const bets = {};
  const betGroups = [];

  _.forOwn(rawData[parserMap.tournaments], (value) => {
    const parsedTour = new Tournament(value);
    tournaments[parsedTour.id] = parsedTour;
  });

  _.forOwn(rawData[parserMap.categories], (value) => {
    const parsedCategory = new Category(value);
    categories[parsedCategory.id] = parsedCategory;
    categories[parsedCategory.id].tournaments = _.sortBy(_.filter(tournaments, { idCategory: parsedCategory.id }), ['position', 'name']);
  });

  _.forOwn(rawData[parserMap.sports], (value) => {
    const parsedSport = new Sport(value);
    sports[parsedSport.id] = parsedSport;
  });


  _.forOwn(rawData[parserMap.bets], (value) => {
    const parsedBet = new Bet(value);
    bets[parsedBet.id] = parsedBet;
  });

  if (rawData[parserMap.betGroups]) {
    rawData[parserMap.betGroups].forEach(value => betGroups.push(new BetGroup(value)));
  }

  return {
    tournaments,
    categories,
    sports,
    bets,
    betGroups,
  };
};

const formatTopOffer = (rawData) => {
  const categories = {};
  const matches = [];
  const sports = {};
  const tournaments = {};

  _.forOwn(rawData[parserMap.categories], (value) => {
    const parsedCategory = new Category(value);
    categories[parsedCategory.id] = parsedCategory;
  });

  _.forOwn(rawData[parserMap.sports], (value) => {
    const parsedSport = new Sport(value);
    sports[parsedSport.id] = parsedSport;
  });

  _.forOwn(rawData[parserMap.tournaments], (value) => {
    const parsedTour = new Tournament(value);

    parsedTour.categoryPosition = categories[parsedTour.idCategory].position;

    tournaments[parsedTour.id] = parsedTour;
  });

  rawData[parserMap.matches].forEach((value) => {
    const match = new Match(value);

    const sport = sports[match.idSport] || {};
    match.sportPosition = sport.position;
    match.sport = sport;

    const category = categories[match.idCategory] || {};
    match.categoryPosition = category.position;
    match.category = category;

    const tournament = tournaments[match.idTournament] || {};
    match.tournamentPosition = tournament.position;
    match.tournament = tournament;

    matches.push(match);
  });

  return {
    categories,
    matches,
    sports,
    tournaments,
  };
};

const mapMatchBets = (matches, bets) => {
  matches.forEach((match) => {
    match.mapBets(bets);
  });
};

const formatOffer = (rawData, noBets, getters) => {
  const matches = _.map(rawData[parserMap.matches], ((value) => {
    const match = new Match(value, noBets);

    const sport = getters.getSportById(match.idSport) || {};
    const category = getters.getCategoryById(match.idCategory) || {};
    const tournament = getters.getTournamentById(match.idTournament) || {};

    match.sportPosition = sport.position || Number.MAX_SAFE_INTEGER;
    match.categoryPosition = category.position || Number.MAX_SAFE_INTEGER;
    match.tournamentPosition = tournament.position || Number.MAX_SAFE_INTEGER;
    match.category = category;
    match.tournament = tournament;
    match.tournamentName = tournament.name || tournament.shortName;
    match.categoryName = category.name || category.shortName;

    return match;
  }));

  return _.sortBy(matches, ['sportPosition', 'categoryPosition', 'categoryName', 'tournamentPosition', 'tournamentName', 'timestamp']);
};

const formatMatch = rawData => new Match(rawData);

const formatOutrights = data => data[parserMap.matches].map(value => new Match(value, false, true));

export default {
  formatMeta,
  formatTopOffer,
  formatMatch,
  formatOffer,
  mapMatchBets,
  formatOutrights,
};
